'use client';

// This is a no-op analytics hook that replaces the Amplitude implementation
// We can implement actual analytics here later if needed
export function useAnalytics() {
  const trackClick = (buttonName: string, buttonLocation?: string) => {};
  const trackForm = (formName: string, formData?: Record<string, any>) => {};
  const trackFeature = (featureName: string, action: string) => {};

  return {
    trackClick,
    trackForm,
    trackFeature,
  };
} 